import { redirect } from '@tanstack/react-router'

import type { ContextoRouter } from '@/routes/__root'

type Sessao = Awaited<ReturnType<ContextoRouter['trpcClient']['auth']['me']['query']>>
type Perfil = Sessao['perfil']

/**
 * `beforeLoad` das rotas que exigem sessão web (gestão, diretoria, painel):
 * busca `auth.me` (cache curto por rota) e, sem sessão ou com perfil fora de
 * `perfis`, manda para o login com retorno à mesma URL.
 */
export async function exigirSessao({
  context,
  location,
  perfis,
}: {
  context: ContextoRouter
  location: { pathname: string }
  /** Perfis aceitos; sem a lista, qualquer sessão serve (ex.: TV do painel). */
  perfis?: readonly Perfil[]
}): Promise<Sessao> {
  const me = await context.queryClient
    .fetchQuery({
      queryKey: ['auth', 'me', location.pathname],
      queryFn: () => context.trpcClient.auth.me.query(),
      staleTime: 10_000,
      retry: false,
    })
    .catch(() => null)
  if (!me || (perfis && !perfis.includes(me.perfil))) {
    // O TanStack Router pede que o redirect seja lançado (a regra fica desligada nas rotas).
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/login', search: { redirect: location.pathname } })
  }
  return me
}

/** Gestão/PCP e Diretoria: quem entra pela web. Operador só entra pelo tablet. */
export const PERFIS_WEB = ['GESTAO', 'DIRETORIA'] as const satisfies readonly Perfil[]
